import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { store } from './store'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AlertModal } from '@/components/common'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <TooltipProvider>
          <App />
          <AlertModal />
        </TooltipProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
